/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @author Dmitriy Kvon
 * @version 1.22.0
 * @since 1.16.0
 */

import { IWizardImportPersonalDataReducer } from './wizardImportPersonalDataReducer';

export enum EWizardImportPersonalDataSteps {
    DocumentSelectionStep = 'DocumentSelectionStep',
    ContentValidationStep = 'ContentValidationStep',
    ConfirmImportStep = 'ConfirmImportStep',
}

export const initWizardImportPersonalDataState: IWizardImportPersonalDataReducer = {
    errorCode: '',
    errorRowsAmount: 0,
    fileName: '',
    fileRowsAmount: 0,
    fileTemplateUrl: '',
    maxImportSubscriberAmount: 0,
    removedRowsAmount: 0,
    resultFileId: '',
    validation: {
        error: '',
        isValid: false,
    },
};

export enum EImportPersonalDataField {
    ACTION = 'action',
    ADDR_APARTMENT = 'apartment',
    ADDR_BLOCK = 'block',
    ADDR_CITY = 'city',
    ADDR_COUNTRY = 'country',
    ADDR_HOUSE = 'house',
    ADDR_REGION = 'province',
    ADDR_STREET = 'street',
    ADDR_STRUCTURE = 'structure',
    BIRTH_DATE = 'birthDateStr',
    BIRTH_PLACE = 'birthPlace',
    DOC_DEPARTMENT_CODE = 'docDepartmentCode',
    DOC_ISSUE_DATE = 'docIssueDateStr',
    DOC_ISSUED_BY = 'docIssuedBy',
    DOC_NUMBER = 'docNumber',
    DOC_NUMBER_FROM_FILE = 'fileDocNumber',
    DOC_SERIES = 'docSeries',
    DOC_TYPE = 'docName',
    DOC_VALID_DATE = 'docValidDateStr',
    EMAIL = 'email',
    FIO = 'fullName',
    FIO_FROM_FILE = 'fileFullName',
    MSISDN = 'msisdn',
    NAME = 'name',
    NATIONALITY_INFO = 'nationalityInfo',
    PATRONYMIC = 'patronymic',
    PIC_STATUS = 'picStatus',
    PLANNING_ELEMENT = 'planningElement',
    STATUS = 'status',
    SURNAME = 'surname',
}

/*
* -------------------------------------------
*           ACTIONS
* -------------------------------------------
*/

export const WIZARD_IMPORT_PERSONAL_DATA_HANDLE_NEXT =
    '@@b2b_portal_ui/wizardImportPersonalData/WIZARD_IMPORT_PERSONAL_DATA_HANDLE_NEXT';

export const WIZARD_IMPORT_PERSONAL_DATA_SET_PARAMS =
    '@@b2b_portal_ui/wizardImportPersonalData/WIZARD_IMPORT_PERSONAL_DATA_SET_PARAMS';

export const WIZARD_IMPORT_PERSONAL_DATA_START_VALIDATE =
    '@@b2b_portal_ui/wizardImportPersonalData/WIZARD_IMPORT_PERSONAL_DATA_START_VALIDATE';
export const WIZARD_IMPORT_PERSONAL_DATA_SET_STEP_VALID =
    '@@b2b_portal_ui/wizardImportPersonalData/WIZARD_IMPORT_PERSONAL_DATA_SET_STEP_VALID';

/*
* -------------------------------------------
*          ATTACH FILE
* -------------------------------------------
*/

export const WIZARD_IMPORT_PERSONAL_DATA_ATTACH_FILE =
    '@@b2b_portal_ui/wizardImportPersonalData/WIZARD_IMPORT_PERSONAL_DATA_ATTACH_FILE';
export const WIZARD_IMPORT_PERSONAL_DATA_ATTACH_FILE_SUCCESSFUL =
    '@@b2b_portal_ui/wizardImportPersonalData/WIZARD_IMPORT_PERSONAL_DATA_ATTACH_FILE_SUCCESSFUL';
export const WIZARD_IMPORT_PERSONAL_DATA_ATTACH_FILE_FAILED =
    '@@b2b_portal_ui/wizardImportPersonalData/WIZARD_IMPORT_PERSONAL_DATA_ATTACH_FILE_FAILED';

/*
* -------------------------------------------
*          LOAD TABLE DATA
* -------------------------------------------
*/
export const WIZARD_IMPORT_PERSONAL_DATA_INIT_VALIDATED_LIST =
    '@@b2b_portal_ui/wizardImportPersonalData/WIZARD_IMPORT_PERSONAL_DATA_INIT_VALIDATED_LIST';

export const WIZARD_IMPORT_PERSONAL_DATA_INIT_VALIDATED_LIST_FAILED =
    '@@b2b_portal_ui/wizardImportPersonalData/WIZARD_IMPORT_PERSONAL_DATA_INIT_VALIDATED_LIST_FAILED';
